import httpService from "./httpService";

const apiEndpoint = process.env.REACT_APP_API + "/worldregions";
const tokenKey = process.env.jumelage_jwtPrivateKey;

export function getWorldRegionsList(language){
    const jwt = sessionStorage.getItem(tokenKey);
    let lang = language;
    if(!lang){ lang="fr"}
    return httpService.get(apiEndpoint + "?locale=" +lang, {headers: {"x-auth-token" : jwt}})
}

export function getAllWorldRegions(filterString){
    const jwt = sessionStorage.getItem(tokenKey);
    return httpService.get(apiEndpoint + "/?filterString=" + filterString + "&showInactive=1", {headers: {"x-auth-token" : jwt}})
}

export function getWorldRegionByID(id){
    const jwt = sessionStorage.getItem(tokenKey);
    return httpService.get(`${apiEndpoint}/${id}`, {headers: {"x-auth-token" : jwt}})
}

export function UpdateWorldRegion(worldRegionObject){
    try{
        const jwt = sessionStorage.getItem(tokenKey);
        const id = worldRegionObject.id;
        return httpService.put(`${apiEndpoint}/${id}`, worldRegionObject, {headers: {"x-auth-token" : jwt}});
    } catch (ex){
        return null;
    }
}

export function CreateNewWorldRegion(worldRegionObject){
    if(worldRegionObject.id !== undefined)
        delete worldRegionObject.id

    try{
        const jwt = sessionStorage.getItem(tokenKey);
        return httpService.post(`${apiEndpoint}`, worldRegionObject, {headers: {"x-auth-token" : jwt}});
    } catch (ex){
        return null;
    }
}